export default __webpack_public_path__ + "static/media/3.52e1c994.jpeg";